import {Component, Inject, OnDestroy, OnInit, Renderer2} from '@angular/core';
import {FormGroup, FormControl, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {AuthService} from "../auth.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {Direction} from "@angular/cdk/bidi";
import {InConfiguration} from "../models/config.interface";
import {DirectionService} from "../services/direction.service";
import {DOCUMENT} from "@angular/common";
import {ConfigService} from "../services/config.service";
import {LogService} from "../services/log.service";
import {Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {
  private _destroyed$ = new Subject<void>();
  direction!: Direction;
  public config!: InConfiguration;
  changePassword = false;
  changePasswordForm!: FormGroup;
  loginForm!: FormGroup;
  type: string = "password";
  isText: Boolean = false;
  eyeIcon: string = "fa-eye-slash";

  // Loader states
  isLoggingIn: boolean = false;
  isResettingPassword: boolean = false;

  constructor(private router: Router,
              private _matSnackbar: MatSnackBar,
              private logService: LogService,
              private authService: AuthService,
              private directoryService: DirectionService,
              @Inject(DOCUMENT) private document: Document,
              private configService: ConfigService,
              private renderer: Renderer2) {
    this.initlayout()
  }

  ngOnInit(): void {
    this.loginForm = new FormGroup({
      email: new FormControl('', [Validators.required]),
      password: new FormControl('', [Validators.required]),
    })
    this.changePasswordForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email]),
    })
  }

  async loginUser() {
    if (this.isLoggingIn) return; // Prevent multiple clicks

    this.isLoggingIn = true;
    console.log(this.loginForm.value);

    try {
      await this.authService.SignIn(
        this.loginForm.value['email'],
        this.loginForm.value['password']
      );
      // Keep button disabled - user will be redirected to dashboard
    } catch (error) {
      console.error('Login error:', error);
      // Re-enable button only on error
      this.isLoggingIn = false;
    }
  }

  get username() {
    return this.loginForm.get('email');
  }

  get password() {
    return this.loginForm.get('password');
  }

  hideshowpass() {
    this.isText = !this.isText;
    this.isText ? this.eyeIcon = "fa-eye" : this.eyeIcon = " fa fa-eye-slash";
    this.isText ? this.type = "text" : this.type = "password";
  }

  logout() {
    this.authService.SignOut();
    console.log(this.loginForm)
  }

  forgotPassword() {
    this.changePassword = true;
  }

  async submitForgotPassword(email: string) {
    if (this.isResettingPassword) return; // Prevent multiple clicks

    this.isResettingPassword = true;

    try {
      await this.authService.changePassword(email);
      this._matSnackbar.open(
        `A verification email has been sent to ${email}`,
        'EMAIL SENT',
        { duration: 4000 }
      );
      // Reset form after successful submission
      setTimeout(() => {
        this.backToLogin();
      }, 2000);
    } catch (error) {
      this._matSnackbar.open(
        `Failed: email not found`,
        'ERROR',
        { duration: 4000 }
      );
    } finally {
      this.isResettingPassword = false;
    }
  }

  private initlayout() {
    this.config = this.configService.configData;
    this.directoryService.currentData.pipe(takeUntil(this._destroyed$)).subscribe((currentData) => {
      if (currentData) {
        this.direction = currentData === 'ltr' ? 'ltr' : 'rtl';
      } else {
        if (localStorage.getItem('isRtl')) {
          if (localStorage.getItem('isRtl') === 'true') {
            this.direction = 'rtl';
          } else if (localStorage.getItem('isRtl') === 'false') {
            this.direction = 'ltr';
          }
        } else {
          if (this.config) {
            if (this.config.layout.rtl === true) {
              this.direction = 'rtl';
              localStorage.setItem('isRtl', 'true');
            } else {
              this.direction = 'ltr';
              localStorage.setItem('isRtl', 'false');
            }
          }
        }
      }
    });

    // set theme on startup
    if (localStorage.getItem('theme')) {
      this.renderer.removeClass(this.document.body, this.config.layout.variant);
      this.renderer.addClass(
        this.document.body,
        localStorage.getItem('theme') as string
      );
    } else {
      this.renderer.addClass(this.document.body, this.config.layout.variant);
    }
  }

  backToLogin() {
    this.changePassword = false;
    this.changePasswordForm.reset();
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }
}
